export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4618.f5f8fcde.jpg";